export const ADD_HOTKEY = Symbol('ADD_HOTKEY');
export const REMOVE_HOTKEY = Symbol('REMOVE_HOTKEY');
export const SET_HOTKEYS = Symbol('SET_HOTKEYS');
